class TutorialStepsComponent extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.applySettings();
    this.addScrollAnimations();
  }

  applySettings() {
    // Apply dynamic CSS custom properties from section settings
    const section = this.closest('.section');
    if (!section) return;

    const titleSize = section.dataset.titleSize || '2rem';
    const descriptionSize = section.dataset.descriptionSize || '1rem';

    this.style.setProperty('--tutorial-title-size', titleSize);
    this.style.setProperty('--tutorial-description-size', descriptionSize);
  }

  addScrollAnimations() {
    const steps = this.querySelectorAll('.tutorial-step');
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    steps.forEach(step => {
      step.style.opacity = '0';
      step.style.transform = 'translateY(20px)';
      step.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      observer.observe(step);
    });
  }
}

customElements.define('tutorial-steps-component', TutorialStepsComponent);